import * as angular from 'angular';
import View from '../view';
import type { EntityContext } from '../../../PandoraSolutionBuilderAgent/services/entity-service';

/**
 * @ngdoc type
 * @name mx.shell.WizardView
 * @module mx.shell
 * @augments mx.shell.View
 *
 * @description
 * An implementation of the Wizard View for {@ref mx.shell:mxSidePanel side panel}
 * A constructor accepts `options` parameter that may contain fields to extend corresponding properties. Created like:
 * ```javascript
 var options = {
	id: 'simple-wizard',
	type: 'simple_wiz',
	name: 'Simple wizard',
	displayName: 'Simple tests wizard'
 };

 var view = new mx.shell.WizardView(options);
 * ```
 *
 * @property {string} uiActionGroup - A name of a group of actions to be displayed. Read-only. Defaults to `wizard`
 * @property {boolean} isWizard - Property that determines view as a wizard view. Read-only. Defaults to `true`
 * @property {function} initView - A function to be executed before view compilation.
 * @property {boolean} dirty - True if user has already interacted with the form. Always true for wizards.
 *
 */
export default class WizardView extends View {
	public actionContext: EntityContext[];
	public mergeDisabled = false;
	public telemetrySource?: string;

	constructor(options: Partial<WizardView> = {}) {
		super(options);

		this.telemetrySource = options.telemetrySource;
		this.actionContext = options.actionContext || [];

		Object.defineProperties(this, {
			uiActionGroup: { writable: false, enumerable: true, value: ['wizard'] },
			isWizard: { writable: false, enumerable: true, value: true },
			initView: { writable: true, enumerable: true },
			dirty: { enumerable: true, writable: true, value: false },
			mergeDisabled: { enumerable: true, writable: true, value: Boolean(options.mergeDisabled) },
		});
	}

	getWizard() {
		return this.locals.wizard;
	}
}

angular.module('mx.shell').value('mx.shell.WizardView', WizardView);
